import { connect } from 'react-redux';
import { selectDesktopNavIsCollapsed } from 'features/Sidenav/selectors';
import FooterForm from './FooterForm';

export const mapStateToProps = state => ({
  desktopNavIsCollapsed: selectDesktopNavIsCollapsed(state),
});

export default connect(mapStateToProps)(FooterForm);
